import { Component } from '@theme/component';

/** Keeps decorative motion pausable without changing shopping interactions. */
class FestiveAtmosphere extends Component {
  #abort;
  #paused = false;
  connectedCallback() {
    super.connectedCallback();
    this.#abort?.abort();
    this.#abort = new AbortController();
    try { this.#paused = sessionStorage.getItem('shopgatehub-festive-paused') === 'true'; } catch { /* Storage is optional. */ }
    document.addEventListener('visibilitychange', this.#visibility, { signal: this.#abort.signal });
    this.#visibility();
    this.#render();
  }
  updatedCallback() { super.updatedCallback(); this.#render(); }
  toggleMotion() {
    this.#paused = !this.#paused;
    try { sessionStorage.setItem('shopgatehub-festive-paused', String(this.#paused)); } catch { /* Storage is optional. */ }
    this.#render();
  }
  #visibility = () => { document.documentElement.toggleAttribute('data-festive-hidden', document.hidden); };
  #render() {
    document.documentElement.toggleAttribute('data-festive-paused', this.#paused);
    const button = this.refs.toggle;
    if (!button || !this.refs.label) return;
    button.hidden = false;
    button.setAttribute('aria-pressed', String(this.#paused));
    this.refs.label.textContent = this.#paused ? button.dataset.play : button.dataset.pause;
  }
  disconnectedCallback() {
    this.#abort?.abort();
    document.documentElement.removeAttribute('data-festive-hidden');
    document.documentElement.removeAttribute('data-festive-paused');
    super.disconnectedCallback();
  }
}
if (!customElements.get('festive-atmosphere')) customElements.define('festive-atmosphere', FestiveAtmosphere);
